import { useCallback } from 'react';

import { getAccessToken } from 'utilities/base-auth';
import { request } from 'utilities/base-auth/axios';

// Resolves the workspace id for an org from the accounts host. Replaces the
// deprecated user.default_workspace_id (removed from the User entity on
// 2026-07-01). The org response exposes the workspace_id directly.
const useOrgWorkspaceId = () => {
  const getOrgWorkspaceId = useCallback(async orgId => {
    const response = await request.get(
      `/v2/orgs/${orgId}?attributes=workspaces`,
      {
        headers: {
          common: {
            Authorization: `Bearer ${getAccessToken()}`
          }
        },
        useCache: false
      }
    );
    return response?.data?.workspace_id;
  }, []);

  return { getOrgWorkspaceId };
};

export default useOrgWorkspaceId;
